import { gql } from '@apollo/client';

export const GET_SUBDIVISIONS_QUERY = gql`
  query getSubdivisionsQuery($group_id: String, $company_id: String) {
    subdivisions(group_id: $group_id, company_id: $company_id) {
      id
      deleted
      name
      division {
        id
        name
        reference {
          path
        }
      }
      archived
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const ALLOW_DELETE_SUBDIVISIONS_QUERY = gql`
  query allowDeleteSubdivisionsQuery(
    $group_id: String
    $company_id: String
    $subdivision_id: String
  ) {
    allowDeleteSubdivision(
      group_id: $group_id
      company_id: $company_id
      subdivision_id: $subdivision_id
    )
  }
`;
